import type {
  SettingKey,
  SettingValue,
  SaveDefaultSettingsBody,
  DefaultSettingResponse,
} from "src/shared/api-types/user";

import request from "./request";

export const getDefaultSettings = async (key: SettingKey, crewId?: number): Promise<DefaultSettingResponse | null> => {
  try {
    const params = new URLSearchParams();
    if (crewId !== undefined) {
      params.append("crewId", String(crewId));
    }
    const queryString = params.toString();
    const url = `user-settings/defaults/${key}${queryString ? `?${queryString}` : ""}`;

    const response = await request(url);
    return response;
  } catch (error) {
    if (error === 404) {
      return null;
    }
    throw error;
  }
};

export const saveDefaultSettings = async (
  key: SettingKey,
  value: SettingValue,
  crewId?: number,
): Promise<DefaultSettingResponse> => {
  const body: SaveDefaultSettingsBody = {
    value,
    crewId: crewId ?? null,
  };

  const response = await request(`user-settings/default/${key}`, "POST", body);
  return response;
};
